import type { PreferenceValues } from '@nest-recruit/shared';
import { useRecents } from '../stores/recents';
import { useUi } from '../stores/ui';
import { loadServerPreferences } from './preferences';

export const PREFERENCES_KEY = ['me', 'preferences'] as const;

/** Once per sign-in: the server's copy into the browser, then the stores that read at start re-read. */
export async function loadPreferencesFor(userId: string): Promise<PreferenceValues> {
  try {
    return await loadServerPreferences(userId);
  } finally {
    // Even when the server is unreachable, the browser's own copy is read.
    useUi.getState().loadPreferences();
    useRecents.getState().load();
  }
}
